import { render, staticRenderFns } from "./EditPartakerForList.vue?vue&type=template&id=2bd31168&scoped=true&"
import script from "./EditPartakerForList.ts?vue&type=script&lang=ts&"
export * from "./EditPartakerForList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd31168",
  null
  
)

export default component.exports